<template>
  <n-select :value="selection" :options="selections" :multiple="multiple" placeholder="请选择" @update:value="onUpdateSelection" filterable :maxTagCount="'responsive'" style="width: 160px"> </n-select>
</template>
<script lang="ts" setup>
import { watch, computed } from "vue"
import { getAddressesByParentCode } from "@/common/address/AddressUtil"
import { SelectionItem } from "@/common/model/SelectionItem"

const props = withDefaults(
  defineProps<{
    value: number | Array<number> | null
    parentCode: number
    multiple?: boolean
  }>(),
  {
    multiple: false,
  },
)
const emits = defineEmits<{
  "update:value": [code: number | Array<number> | null]
}>()

const selection = computed(() => {
  if (props.value == null) {
    return null
  } else if (Array.isArray(props.value)) {
    const result = [] as Array<string>
    for (const item of props.value) {
      result.push(item + "")
    }
    return result
  } else {
    return props.value + ""
  }
})

const getSelectionsByParentCode = (parentCode: number): Array<SelectionItem> => {
  const addresses = getAddressesByParentCode(parentCode)
  const result = [] as Array<SelectionItem>
  for (const address of addresses) {
    result.push({ label: address.name, value: address.code + "" })
  }
  return result
}

const selections = computed(() => getSelectionsByParentCode(props.parentCode))

const onUpdateSelection = (selection: string | string[] | null) => {
  if (selection == null) {
    emits("update:value", null)
  } else if (Array.isArray(selection)) {
    const result = [] as Array<number>
    for (const item of selection) {
      result.push(Number.parseInt(item))
    }
    emits("update:value", result)
  } else {
    emits("update:value", Number.parseInt(selection))
  }
}

watch(
  () => props.parentCode,
  () => {
    if (props.multiple) {
      onUpdateSelection([])
    } else {
      onUpdateSelection(null)
    }
  },
)
</script>
<style scoped></style>
